const PageNotFound : React.FC = () =>
<div>
    <h2>Page not found!</h2>
</div>
;

export default PageNotFound;
